export default "__VITE_ASSET__CShj3ECC__"